<template>
	<div class="appView">
		<Sidebar></Sidebar>
		<div class="contentView settingsView expensesView">
			<div
				class="navigationView"
				:class="{ stackScreen: !splitScreen }"
				v-if="!showView || splitScreen"
			>
				<div class="navBar">
					<Hamburger />
					<div class="title">Settings</div>
					<div class="separator"></div>
				</div>

				<div class="settingsList tableView">
					<div class="tableSection sectionAccount">
						<div
							class="block settingsSection sectionAccount"
							:class="[showView == 'profile' ? 'selected' : '']"
							@click="showView = showView == 'profile' ? null : 'profile'"
						>
							<div class="icon">
								<div class="initials">PA</div>
							</div>
							<div class="details">
								<div class="title name">
									{{ profile.firstName }} {{ profile.lastName }}
								</div>
								<div class="subtitle email" :title="profile.userEmail">
									{{ profile.userEmail }}
								</div>
							</div>
						</div>
					</div>

					<div class="tableSection sectionGeneral">
						<div
							class="block settingsSection sectionProjects"
							:class="[showView == 'project' ? 'selected' : '']"
							@click="showView = showView == 'project' ? null : 'project'"
						>
							<div class="icon"></div>
							<!-- <img
								v-if="showView === 'project'"
								class="settingsIcons"
								src="../resources/svg-icons/settings/project-icon-white.svg"
								alt=""
							/>
							<img
								v-else
								class="settingsIcons"
								src="../resources/svg-icons/settings/project-icon-theme.svg"
								alt=""
							/> -->
							<div class="title">Projects</div>
						</div>

						<div
							class="block settingsSection sectionCategories"
							:class="[showView == 'category' ? 'selected' : '']"
							@click="showView = showView == 'category' ? null : 'category'"
						>
							<div class="icon"></div>
							<!-- <img
								v-if="showView === 'category'"
								class="settingsIcons"
								src="../resources/svg-icons/settings/categories-icon-white.svg"
								alt=""
							/>
							<img
								v-else
								class="settingsIcons"
								src="../resources/svg-icons/settings/categories-icon-theme.svg"
								alt=""
							/> -->
							<div class="title">Categories</div>
						</div>

						<div
							class="block settingsSection sectionVendor"
							:class="[showView == 'vendor' ? 'selected' : '']"
							@click="showView = showView == 'vendor' ? null : 'vendor'"
						>
							<div class="icon"></div>
							<!-- <img
								v-if="showView === 'vendor'"
								class="settingsIcons"
								src="../resources/svg-icons/settings/vendors-icon-white.svg"
								alt=""
							/>
							<img
								v-else
								class="settingsIcons"
								src="../resources/svg-icons/settings/vendors-icon-theme.svg"
								alt=""
							/> -->
							<div class="title">Vendors</div>
						</div>
					</div>

					<div class="tableSection sectionGeneral">
						<div
							class="block settingsSection sectionPaymentMethod"
							:class="[showView == 'paymenttype' ? 'selected' : '']"
							@click="
								showView = showView == 'paymenttype' ? null : 'paymenttype'
							"
						>
							<div class="icon"></div>
							<!-- <img
								v-if="showView === 'paymenttype'"
								class="settingsIcons"
								src="../resources/svg-icons/settings/payment-method-icon-white.svg"
								alt=""
							/>
							<img
								v-else
								class="settingsIcons"
								src="../resources/svg-icons/settings/payment-method-icon-theme.svg"
								alt=""
							/> -->
							<div class="title">Payment Methods</div>
						</div>

						<div
							class="block settingsSection sectionPayer"
							:class="[showView == 'payer' ? 'selected' : '']"
							@click="showView = showView == 'payer' ? null : 'payer'"
						>
							<div class="icon"></div>
							<!-- <img
								v-if="showView === 'payer'"
								class="settingsIcons"
								src="../resources/svg-icons/settings/payer-icon-white.svg"
								alt=""
							/>
							<img
								v-else
								class="settingsIcons"
								src="../resources/svg-icons/settings/payer-icon-theme.svg"
								alt=""
							/> -->
							<div class="title">Payers</div>
						</div>
					</div>

					<div class="tableSection sectionSupport">
						<div class="block settingsSection sectionFeedback">
							<div class="title">
								<a href="mailto:support@rapidreceipt.io">Feedback & Help</a>
							</div>
						</div>
						<div class="block settingsSection sectionTerms">
							<div class="title">
								<a href="https://rapidreceipt.io/terms" target="_blank"
									>Terms</a
								>
								&
								<a href="https://rapidreceipt.io/privacy" target="_blank"
									>Privacy</a
								>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div id="profile-detail" class="detailView" v-if="showView == 'profile'">
				<div class="navBar">
					<button
						v-if="!splitScreen"
						class="backToSettings"
						@click="hideFields"
					>
						<font-awesome-icon :icon="['fas', 'chevron-left']" />
						<span class="text">Settings</span>
					</button>
					<div class="title">Account Details</div>
					<div
						v-if="isAccFirstNameEdit || isAccLastNameEdit"
						class="title-action-btns"
					>
						<b-button
							class="btn-default btn-cancel"
							@click="onCancelAccountUpdateDetails"
							>Cancel</b-button
						>
						<b-button
							class="btn-default btn-submit"
							@click="updateAccountDetail()"
							>Done</b-button
						>
					</div>
					<div class="separator"></div>
				</div>

				<div class="detailsList tableView">
					<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
					<div class="tableSection sectionName">
						<div
							class="block firstName"
							@click="editAccountDetail('firstname')"
						>
							<div class="title">First Name</div>
							<div class="detail">
								<span v-if="!isAccFirstNameEdit">{{ profile.firstName }}</span>
								<span v-else>
									<input
										type="text"
										ref="firstName"
										v-model="profile.firstName"
										class="form-control edit-profile-input"
									/>
								</span>
							</div>
						</div>
						<div class="block lastName" @click="editAccountDetail('lastname')">
							<div class="title">Last Name</div>
							<div class="detail">
								<span v-if="!isAccLastNameEdit">{{ profile.lastName }}</span>
								<span v-else>
									<input
										type="text"
										ref="lastName"
										v-model="profile.lastName"
										class="form-control edit-profile-input"
									/>
								</span>
							</div>
						</div>
					</div>

					<div class="tableSection sectionEmail">
						<div class="block email">
							<div class="title">Email</div>
							<div class="detail">{{ profile.userEmail }}</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="detailView defaultCurrencyView"
				:class="{ stackScreen: !splitScreen }"
				v-if="showView == 'project'"
			>
				<div class="navBar">
					<button
						v-if="!splitScreen"
						class="backToSettings"
						@click="hideFields"
					>
						<font-awesome-icon :icon="['fas', 'chevron-left']" />
						<span class="text">Settings</span>
					</button>
					<div class="title">Manage Projects</div>
					<div class="separator"></div>
					<div class="actions">
						<button class="action addReceipt" @click="addProject">
							<img src="../../public/svg/plus-icon-white.svg" alt="" />
							<span>Add a New Project</span>
						</button>
					</div>
				</div>

				<div class="currencyList tableView">
					<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
					<div class="tableSection sectionRecommended">
						<SlickList lockAxis="y" v-model="projects">
							<SlickItem
								v-for="(project, projectKey) in projects"
								:index="projectKey"
								:key="projectKey"
								class="itemBg"
							>
								<div class="project-name">{{ project.Name }}</div>
								<div class="btnAction">
									<b-button
										class="action-btn del-btn"
										@click="
											showDeleteConfirm('project', () =>
												deleteProject(project.Name)
											)
										"
									>
										<font-awesome-icon
											:icon="['fas', 'trash']"
											class="btn-icons"
										/>
									</b-button>
									<b-button
										class="action-btn"
										type="submit"
										@click="renameProject(project.Name)"
										><img
											class="rename-icon"
											src="./../resources/images/rename.png"
										/>
										Rename
									</b-button>
									<span class="sort-btn">
										<font-awesome-icon
											:icon="['fas', 'bars']"
											class="btn-icons"
										/>
									</span>
								</div>
							</SlickItem>
						</SlickList>
					</div>
				</div>
			</div>

			<div class="detailView defaultCurrencyView" v-if="showView == 'category'">
				<div class="navBar">
					<button
						v-if="!splitScreen"
						class="backToSettings"
						@click="hideFields"
					>
						<font-awesome-icon :icon="['fas', 'chevron-left']" />
						<span class="text">Settings</span>
					</button>
					<div class="title">Manage Categories</div>
					<div class="separator"></div>
					<div class="actions">
						<button class="action addReceipt" @click="addCategory">
							<img src="../../public/svg/plus-icon-white.svg" alt="" />
							<span>Add a New Category</span>
						</button>
					</div>
				</div>

				<div class="currencyList tableView expensesList">
					<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
					<div class="tableSection sectionRecommended">
						<div
							v-for="(category, typeKey) in attributes.category"
							class="block expense"
							:class="'category' + getCategoryIcon(category.Name)"
							:key="typeKey"
						>
							<div class="details">
								<div class="icon">
									<div class="glyph"></div>
								</div>
								<div class="detaisWarpper">
									<div class="title vendor">{{ category.Name }}</div>
									<div class="subtitle category">
										{{ category.NumOfReceipts }} expenses
									</div>
								</div>
								<div class="actionCat">
									<b-button
										class="action-btn del-btn"
										@click="
											showDeleteConfirm('category', () =>
												deleteCategory(category.Name)
											)
										"
									>
										<font-awesome-icon
											:icon="['fas', 'trash']"
											class="btn-icons"
										/>
									</b-button>
									<b-button
										class="action-btn"
										@click="renameCategory(category.Name)"
									>
										<img
											class="rename-icon"
											src="./../resources/images/rename.png"
										/>
										Rename
									</b-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="detailView defaultCurrencyView" v-if="showView == 'vendor'">
				<div class="navBar">
					<button
						v-if="!splitScreen"
						class="backToSettings"
						@click="hideFields"
					>
						<font-awesome-icon :icon="['fas', 'chevron-left']" />
						<span class="text">Settings</span>
					</button>
					<div class="title">Manage Vendors</div>
					<div class="separator"></div>
					<div class="actions">
						<button class="action addReceipt" @click="addVendor">
							<img src="../../public/svg/plus-icon-white.svg" alt="" />
							<span>Add a New Vendor</span>
						</button>
					</div>
				</div>

				<div class="currencyList tableView expensesList">
					<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
					<div class="tableSection sectionRecommended">
						<div
							v-for="(vendor, typeKey) in attributes.vendor"
							class="block expense"
							:class="'vendor' + getCategoryIcon(vendor.Name)"
							:key="typeKey"
						>
							<div class="details">
								<div class="detaisWarpper">
									<div class="title vendor">{{ vendor.Name }}</div>
									<div class="subtitle vendor">
										{{ vendor.NumOfReceipts }} vendors
									</div>
								</div>
								<div class="actionCat">
									<b-button
										class="action-btn del-btn"
										@click="
											showDeleteConfirm('vendor', () =>
												deleteVendor(vendor.Name)
											)
										"
									>
										<font-awesome-icon
											:icon="['fas', 'trash']"
											class="btn-icons"
										/>
									</b-button>
									<b-button
										class="action-btn"
										@click="renameVendor(vendor.Name)"
									>
										<img
											class="rename-icon"
											src="./../resources/images/rename.png"
										/>
										Rename
									</b-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				class="detailView defaultCurrencyView paymentMethodView"
				v-if="showView == 'paymenttype'"
			>
				<div class="navBar paymentMethodHeader">
					<button
						v-if="!splitScreen"
						class="backToSettings"
						@click="hideFields"
					>
						<font-awesome-icon :icon="['fas', 'chevron-left']" />
						<span class="text">Settings</span>
					</button>
					<div class="title paymentMethodTitle">Manange Payment Methods</div>
					<div class="separator"></div>
					<div class="actions">
						<button class="action addReceipt" @click="addPaymentMethod">
							<img src="../../public/svg/plus-icon-white.svg" alt="" />
							<span>Add a New Payment Method</span>
						</button>
					</div>
				</div>

				<div class="currencyList tableView expensesList">
					<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
					<div class="tableSection sectionRecommended">
						<div
							v-for="(paymentType, typeKey) in attributes.paymenttype"
							class="block expense"
							:class="'payment-type'"
							:key="typeKey"
						>
							<div class="details">
								<div
									class="icon"
									:style="'background-color: ' + paymentType.ColorTranslucent"
								>
									<div class="glyph"></div>
								</div>
								<div class="detaisWarpper">
									<div class="title vendor">{{ paymentType.Name }}</div>
									<div class="subtitle payment-type">
										{{ paymentType.NumOfReceipts }} expenses
									</div>
								</div>
								<div class="actionCat">
									<b-button
										class="action-btn del-btn"
										@click="
											showDeleteConfirm('payment method', () =>
												deletePaymentMethod(paymentType.Name)
											)
										"
									>
										<font-awesome-icon
											:icon="['fas', 'trash']"
											class="btn-icons"
										/>
									</b-button>
									<b-button
										class="action-btn"
										@click="renamePaymentMethod(paymentType.Name)"
									>
										<img
											class="rename-icon"
											src="./../resources/images/rename.png"
										/>
										Rename
									</b-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="detailView defaultCurrencyView" v-if="showView == 'payer'">
				<div class="navBar">
					<button
						v-if="!splitScreen"
						class="backToSettings"
						@click="hideFields"
					>
						<font-awesome-icon :icon="['fas', 'chevron-left']" />
						<span class="text">Settings</span>
					</button>
					<div class="title">Manage Payers</div>
					<div class="separator"></div>
					<div class="actions">
						<button class="action addReceipt" @click="addPayer">
							<img src="../../public/svg/plus-icon-white.svg" alt="" />
							<span>Add a New Payer</span>
						</button>
					</div>
				</div>

				<div class="currencyList tableView expensesList">
					<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
					<div class="tableSection sectionRecommended">
						<div
							v-for="(payer, payerKey) in attributes.payer"
							class="block expense"
							:class="'payer'"
							:key="payerKey"
						>
							<div class="details">
								<div class="detaisWarpper">
									<div class="title vendor">{{ payer.Name }}</div>
									<div class="subtitle payer">
										{{ payer.NumOfReceipts }} expenses
									</div>
								</div>
								<div class="actionCat">
									<b-button
										class="action-btn del-btn"
										@click="
											showDeleteConfirm('payer', () => deletePayer(payer.Name))
										"
									>
										<font-awesome-icon
											:icon="['fas', 'trash']"
											class="btn-icons"
										/>
									</b-button>
									<b-button class="action-btn" @click="renamePayer(payer.Name)">
										<img
											class="rename-icon"
											src="./../resources/images/rename.png"
										/>
										Rename
									</b-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<CreateProject
				v-if="isCreate == 'project'"
				id="addProjectModal"
				@close="isCreate = null"
			></CreateProject>
			<EditProject
				v-if="isEdit == 'project'"
				id="editProjectModal"
				:passParam="passParam"
				@close="isEdit = null"
			></EditProject>

			<CreateCategory
				v-if="isCreate == 'category'"
				id="addCategoryModal"
				@close="isCreate = null"
			></CreateCategory>
			<EditCategory
				v-if="isEdit == 'category'"
				id="editCategoryModal"
				:passParam="passParam"
				@close="isEdit = null"
			></EditCategory>

			<CreateVendor
				v-if="isCreate == 'vendor'"
				id="addVendorModal"
				@close="isCreate = null"
			></CreateVendor>
			<EditVendor
				v-if="isEdit == 'vendor'"
				id="editVendorModal"
				:passParam="passParam"
				@close="isEdit = null"
			></EditVendor>

			<CreatePaymentMethod
				v-if="isCreate == 'paymenttype'"
				id="addPaymentMethodModal"
				@close="isCreate = null"
			></CreatePaymentMethod>
			<EditPaymentMethod
				v-if="isEdit == 'paymenttype'"
				id="editPaymentMethodModal"
				:passParam="passParam"
				@close="isEdit = null"
			></EditPaymentMethod>

			<CreatePayer
				v-if="isCreate == 'payer'"
				id="addPayerModal"
				@close="isCreate = null"
			></CreatePayer>
			<EditPayer
				v-if="isEdit == 'payer'"
				id="editPayerModal"
				:passParam="passParam"
				@close="isEdit = null"
			></EditPayer>
		</div>
		<div
			class="modal-overlay"
			:class="isCreate !== null || isEdit !== null ? 'show-overlay' : ''"
		></div>
	</div>
</template>

<script>
import Auth from "@aws-amplify/auth";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Hamburger from "../components/Hamburger.vue";
import Sidebar from "../components/Sidebar.vue";
import CreateCategory from "../components/CreateCategory.vue";
import EditCategory from "../components/EditCategory.vue";
import CreateVendor from "../components/CreateVendor.vue";
import EditVendor from "../components/EditVendor.vue";
import CreateProject from "../components/CreateProject.vue";
import EditProject from "../components/EditProject.vue";
import CreatePaymentMethod from "../components/CreatePaymentMethod.vue";
import EditPaymentMethod from "../components/EditPaymentMethod.vue";
import CreatePayer from "../components/CreatePayer.vue";
import EditPayer from "../components/EditPayer.vue";

import {
	getUserId,
	getProfile,
	setFirstName,
	setLastName
} from "../utils/auth";
import { mapState } from "vuex";

import { SlickList, SlickItem } from "vue-slicksort";
window._ = require("lodash");

export default {
	data() {
		return {
			fullPage: false,
			isLoading: false,
			profile: getProfile(),
			showView: null,
			isCreate: null,
			isEdit: null,
			passParam: null,
			isAccFirstNameEdit: false,
			isAccLastNameEdit: false,
			splitScreen: screen.width > 1000
		};
	},
	components: {
		Sidebar,
		CreateProject,
		EditProject,
		CreateCategory,
		EditCategory,
		CreateVendor,
		EditVendor,
		Loading,
		SlickItem,
		SlickList,
		CreatePaymentMethod,
		EditPaymentMethod,
		CreatePayer,
		EditPayer,
		Hamburger
	},
	computed: {
		...mapState(["attributes"]),
		projects: {
			get: function() {
				if (this.$store) {
					return _.sortBy(this.$store.state.attributes.project, [
						function(data) {
							return data.Sort;
						}
					]);
				}
				return [];
			},
			set: function(newValue) {
				this.updateProjectOrder(newValue);
			}
		}
	},
	mounted() {
		if (!this.$store.state.attributes.project) {
			this.isLoading = true;
			this.$store.dispatch("loadAttribute").finally(() => {
				this.isLoading = false;
			});
		} else {
			this.isLoading = false;
		}
		const mediaQuery = "(max-width: 1000px)";
		const mediaQueryList = window.matchMedia(mediaQuery);

		mediaQueryList.addEventListener("change", event => {
			if (event.matches) {
				return (this.splitScreen = false);
			}
			return (this.splitScreen = true);
		});
	},
	methods: {
		updateProjectOrder(projectArr) {
			let submitData = [];
			var self = this;
			let userId = getUserId();
			projectArr.forEach(function(result, index) {
				result.Sort = index;
				submitData.push({
					ReceiptAttr: "project|" + result.Name,
					Sort: index
				});
			});
			let params = { user_id: userId, projects: submitData };
			this.$axios
				.post("projects/changeorder", params, { crossdomain: true })
				.then(
					({ data }) => {
						if (data.project.length > 0) {
							this.$store.commit("UPDATE_PROJECT", data.project);
						}
					},
					err => {
						console.log(err);
					}
				);
		},
		addProject() {
			this.isCreate = "project";
		},
		renameProject(name) {
			this.passParam = name;
			this.isEdit = "project";
		},
		async deleteProject(name) {
			try {
				this.isLoading = true;
				let userId = await getUserId();
				let params = {
					data: {
						user_id: userId,
						attribute_type: "project",
						attribute_name: name
					}
				};
				await this.$axios.delete("attributes", params, { crossdomain: true });
				await this.$store.dispatch("loadAttribute");
			} catch (error) {
				return error;
			} finally {
				this.isLoading = false;
				this.$emit("close");
			}
		},

		addCategory() {
			this.isCreate = "category";
		},
		renameCategory(name) {
			this.passParam = name;
			this.isEdit = "category";
		},
		async deleteCategory(categoryName) {
			try {
				this.isLoading = true;
				let userId = await getUserId();
				let params = {
					data: {
						user_id: userId,
						attribute_type: "category",
						attribute_name: categoryName
					}
				};
				await this.$axios.delete("attributes", params, { crossdomain: true });
				await this.$store.dispatch("loadAttribute");
			} catch (error) {
				return error;
			} finally {
				this.isLoading = false;
				this.$emit("close");
			}
		},

		addVendor() {
			this.isCreate = "vendor";
		},
		renameVendor(name) {
			this.passParam = name;
			this.isEdit = "vendor";
		},
		async deleteVendor(vendorName) {
			try {
				this.isLoading = true;
				let userId = await getUserId();
				let params = {
					data: {
						user_id: userId,
						attribute_type: "vendor",
						attribute_name: vendorName
					}
				};
				await this.$axios.delete("attributes", params, { crossdomain: true });
				await this.$store.dispatch("loadAttribute");
			} catch (error) {
				return error;
			} finally {
				this.isLoading = false;
				this.$emit("close");
			}
		},

		addPaymentMethod() {
			this.isCreate = "paymenttype";
		},
		renamePaymentMethod(name) {
			this.passParam = name;
			this.isEdit = "paymenttype";
		},
		async deletePaymentMethod(typeName) {
			try {
				this.isLoading = true;
				let userId = await getUserId();
				let params = {
					data: {
						user_id: userId,
						attribute_type: "paymenttype",
						attribute_name: typeName
					}
				};
				await this.$axios.delete("attributes", params, { crossdomain: true });
				await this.$store.dispatch("loadAttribute");
			} catch (error) {
				return error;
			} finally {
				this.isLoading = false;
				this.$emit("close");
			}
		},

		addPayer() {
			this.isCreate = "payer";
		},
		renamePayer(name) {
			this.passParam = name;
			this.isEdit = "payer";
		},
		async deletePayer(payerName) {
			try {
				this.isLoading = true;
				let userId = await getUserId();
				let params = {
					data: {
						user_id: userId,
						attribute_type: "payer",
						attribute_name: payerName
					}
				};
				await this.$axios.delete("attributes", params, { crossdomain: true });
				await this.$store.dispatch("loadAttribute");
			} catch (error) {
				return error;
			} finally {
				this.isLoading = false;
				this.$emit("close");
			}
		},

		editAccountDetail(field) {
			if (field == "firstname") {
				this.isAccFirstNameEdit = true;
				this.isAccLastNameEdit = false;
				setTimeout(() => {
					this.$refs.firstName.focus();
				}, 300);
			} else {
				this.isAccLastNameEdit = true;
				this.isAccFirstNameEdit = false;
				setTimeout(() => {
					this.$refs.lastName.focus();
				}, 300);
			}
		},
		async updateAccountDetail() {
			this.isLoading = true;
			const user = await Auth.currentAuthenticatedUser();
			const updateAcc = await Auth.updateUserAttributes(user, {
				name: this.profile.firstName,
				family_name: this.profile.lastName
			}).finally(() => {
				this.isAccFirstNameEdit = false;
				this.isAccLastNameEdit = false;
				setFirstName(this.profile.firstName);
				setLastName(this.profile.lastName);
				this.isLoading = false;
			});
		},
		onCancelAccountUpdateDetails() {
			this.isAccFirstNameEdit = false;
			this.isAccLastNameEdit = false;
			this.profile = getProfile();
			setFirstName(this.profile.firstName);
			setLastName(this.profile.lastName);
		},
		hideFields() {
			this.showView = null;
		}
	}
};
</script>
